import {
    CampaignOutlined,
    Dashboard as DashboardIcon,
    Notifications as NotificationsIcon,
    Settings as SettingsIcon,
} from "@mui/icons-material";
import {
    Box,
    Button,
    keyframes,
    Paper,
    Slider,
    styled,
    TextField,
    Typography,
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {setSuccess} from "../../Redux/AlertReducer";
import {Helper} from "../../tools/Helper";
import {api_Routes} from "../../tools/api_Routes";
import ReusableSmmTicketProfileCard from "./SmmTicketProfileCard.tsx";
import ArticleIcon from "@mui/icons-material/Article";
import {SmmticketCampaingsTable} from "./SmmticketCampaingsTable";

// Animation keyframes
const slideIn = keyframes`
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

// Styled components
const SmmTicketCampaignCard = styled(Paper)(({theme}) => ({
    animation: `${slideIn} 0.3s ease-out`,
    transition: "all 0.2s ease",
    "&:hover": {
        transform: "translateY(-2px)",
    },
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
}));
const SmmTicketCampaign = ({data, campaings,getData,currentPage,setCurrentPage,rowsPerPage,setRowsPerPage}) => {

    return (
        <>
            <Box sx={{p: 3, maxWidth: 800, margin: "0 auto"}}>
                <Box sx={{textAlign: "center", mb: 4}}>
                    <CampaignOutlined sx={{fontSize: 40, mb: 1}}/>
                    <Typography variant="h4" gutterBottom>
                        Smmticket Campaign
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Show the Ticket Campaign
                    </Typography>
                </Box>


            </Box>
            <SmmticketCampaingsTable
                campaings={campaings}
                getData={getData}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
            />
        </>

    );
};
export default SmmTicketCampaign;
